// extracted by mini-css-extract-plugin
module.exports = {"table_service_levels":"serviceLevelTable_table_service_levels__ESdWi"};